module.exports = __webpack_public_path__ + "img/shopifyLogo.3916d0ab.svg";